import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { TableIndexColumn } from '@/endpoints/schemas'

interface SortIconProps {
	sortType: TableIndexColumn.SortTypeEnum
}

export const SortIcon = ({ sortType }: SortIconProps) => (
	<OptionSortTypeIcon
		icon={
			sortType === TableIndexColumn.SortTypeEnum.ASC ? faArrowUp : faArrowDown
		}
		color={
			sortType === TableIndexColumn.SortTypeEnum.ASC ? '#28a745' : '#dc3545'
		}
	/>
)

const OptionSortTypeIcon = styled(FontAwesomeIcon)`
	margin-left: 10px;
`
